import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-estatistica-card',
  template: `
    <p-card [style]="{'height': '100%'}">
      <div class="flex justify-content-between mb-3">
        <div>
          <span class="block text-500 font-medium mb-3">{{ titulo }}</span>
          <div class="text-900 font-bold text-xl">{{ valor }}</div>
        </div>
        <div class="flex align-items-center justify-content-center border-round" [ngStyle]="{'background-color': bgColor, 'width': '2.5rem', 'height': '2.5rem'}">
          <i [class]="icone + ' text-xl'" [ngStyle]="{'color': iconColor}"></i>
        </div>
      </div>
      <span class="text-green-500 font-medium" *ngIf="subtitulo">{{ subtitulo }} </span>
      <span class="text-500" *ngIf="descricao">{{ descricao }}</span>
    </p-card>
  `
})
export class EstatisticaCardComponent {
  @Input() titulo: string = '';
  @Input() valor: string | number = '';
  @Input() subtitulo?: string;
  @Input() descricao?: string;
  @Input() icone: string = 'pi pi-chart-bar';
  @Input() bgColor: string = 'var(--blue-100)';
  @Input() iconColor: string = 'var(--blue-500)';
}
